module.exports = __webpack_public_path__ + "static/media/right-arrow-icon.8f8321f5.svg";